import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

class ChannelService {
  async list(search = '') {
    const params = search ? { search: search.trim() } : {};
    const response = await axios.get(`${API_BASE_URL}/channels`, { params });
    return response.data;
  }

  async get(id) {
    const response = await axios.get(`${API_BASE_URL}/channels/${id}`);
    return response.data;
  }

  async create({ name, profileNumber, color, voiceOverConfigId, footageFolderId }) {
    const body = {
      voiceOverConfigId,
      footageFolderId,
      name: name.trim(),
      profileNumber: typeof profileNumber === 'number' ? profileNumber : parseInt(profileNumber, 10),
    };
    if (color !== undefined && color !== null) body.color = typeof color === 'string' ? color.trim() : '';
    const response = await axios.post(`${API_BASE_URL}/channels`, body);
    return response.data;
  }

  async update(id, { name, profileNumber, color, voiceOverConfigId, footageFolderId }) {
    const payload = { voiceOverConfigId, footageFolderId };
    if (name !== undefined) payload.name = name.trim();
    if (profileNumber !== undefined) payload.profileNumber = typeof profileNumber === 'number' ? profileNumber : parseInt(profileNumber, 10);
    if (color !== undefined) payload.color = typeof color === 'string' ? color.trim() : '';
    const response = await axios.put(`${API_BASE_URL}/channels/${id}`, payload);
    return response.data;
  }

  async delete(id) {
    await axios.delete(`${API_BASE_URL}/channels/${id}`);
  }
}

export default new ChannelService();
